import React, { Component } from 'react'
import classes from './DailyFeedbackReport.module.css';
import Button from '../UI/Button/Button';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import CircularProgressBar from '../UI/CircularProgressBar/CircularProgressBar';
import PieChart from '../UI/Charts/PieChart/PieChart';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';


class DailyReportsCard extends Component {

    render() {


        return (
            <>
                <div className={[classes.ReportCard, this.props.showCardLoader ? classes.RemovePadding : ''].join(' ')}>
                    {
                        this.props.showCardLoader
                            ? <ShowLoader isLoading={true} transparentBg={true} />
                            : this.props.feedbackType === "daily" ? <>
                                {(this.props.isProgramManager) ?
                                    <div className={classes.ButtonContainer}>
                                        <Button
                                            label="VIEW ALL RESPONSES"
                                            styleclass="TextOnlyButtonBlue"
                                            clicked={this.props.onViewAllResponsesClicked} />
                                    </div> : null}
                                <h4 className={classes.TopicName}>{this.props.currentTopicDetails.topicName}</h4>
                                {(this.props.isProgramManager) ? <p className={classes.ResponsesText} title="Click to view individual student responses" onClick={this.props.onViewAllResponsesClicked}>{this.props.currentTopicDetails.responsesReceived} RESPONSES</p> : <p className={classes.ResponsesTextInactive} >{this.props.currentTopicDetails.responsesReceived} RESPONSES</p>}

                                <div className={classes.ContainerDiv}>
                                    <div className={classes.ProgressBarsContainer}>
                                        {
                                            !IsListEmpty(this.props.subtopicsResponses)
                                                ? <>
                                                    <p className={classes.DescriptionText}>SUB-TOPICS UNDERSTOOD BY STUDENTS</p>
                                                    <div className={classes.TopicsProgressContainer}>
                                                        {this.props.subtopicsResponses}
                                                    </div>
                                                </>
                                                : null
                                        }


                                        <div className={classes.CircularProgressBarDiv}>
                                            <CircularProgressBar
                                                styleclass={this.props.clearedDoubts.value >= 80 ? "Green" : this.props.clearedDoubts.value >= 70 ? "Yellow" : "Red"}
                                                type="percentage"
                                                progress={this.props.clearedDoubts.value}
                                                showProgressText={true}
                                                progressText={this.props.clearedDoubts.label}
                                            />

                                            <CircularProgressBar
                                                styleclass={this.props.overallSessionRating.value >= 80 ? "Green" : this.props.overallSessionRating.value >= 70 ? "Yellow" : "Red"}
                                                type="fraction"
                                                progress={this.props.overallSessionRating.value}
                                                value={this.props.overallSessionRating.fraction}
                                                showProgressText={true}
                                                progressText={this.props.overallSessionRating.label}
                                            />
                                        </div>
                                    </div>

                                    {
                                        !IsObjectEmpty(this.props.feedbackResponses) && !IsListEmpty(this.props.feedbackResponses.subtopics)
                                            ? <div className={classes.PiechartContainer}>
                                                <p className={classes.DescriptionText}>TOPICS UNDERSTOOD BY STUDENTS</p>
                                                <div className={classes.PieChartDiv}>
                                                    <PieChart
                                                        data={this.props.pieChartData}
                                                    />
                                                    <div className={classes.Legend}>
                                                        <p>Students:</p>
                                                        <p><span className={classes.Green}></span>Completely Understood</p>
                                                        <p><span className={classes.Yellow}></span>Partially Understood</p>
                                                        <p><span className={classes.Red}></span>Did not Understand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }

                                </div>
                            </> : <>
                                {(this.props.isProgramManager) ?
                                    <div className={classes.ButtonContainer}>
                                        <Button
                                            label="VIEW ALL RESPONSES"
                                            styleclass="TextOnlyButtonBlue"
                                            clicked={this.onViewAllResponsesClicked} />
                                    </div> : null}
                                <h4 className={classes.TopicName}>{this.props.currentTopicDetails.topicName}</h4>
                                {(this.props.isProgramManager) ? <p className={classes.ResponsesText} title="Click to view individual student responses" onClick={this.onViewAllResponsesClicked}>{this.props.currentTopicDetails.responsesReceived} RESPONSES</p> : <p className={classes.ResponsesTextInactive} >{this.props.currentTopicDetails.responsesReceived} RESPONSES</p>}

                                <div className={classes.ContainerDiv}>
                                    <div className={classes.ProgressBarsContainer}>
                                        {
                                            !IsListEmpty(this.props.subtopicsResponses)
                                                ? <>
                                                    <p className={classes.DescriptionText}>SUB-TOPICS UNDERSTOOD BY STUDENTS</p>
                                                    <div className={classes.TopicsProgressContainer}>
                                                        {this.props.subtopicsResponses}
                                                    </div>
                                                </>
                                                : null
                                        }


                                        <div className={classes.CircularProgressBarDiv}>
                                            <CircularProgressBar
                                                styleclass={this.props.clearedDoubts.value >= 80 ? "Green" : this.props.clearedDoubts.value >= 70 ? "Yellow" : "Red"}
                                                type="percentage"
                                                progress={this.props.clearedDoubts.value}
                                                showProgressText={true}
                                                progressText={this.props.clearedDoubts.label}
                                            />

                                            <CircularProgressBar
                                                styleclass={this.props.overallSessionRating.value >= 80 ? "Green" : this.props.overallSessionRating.value >= 70 ? "Yellow" : "Red"}
                                                type="fraction"
                                                progress={this.props.overallSessionRating.value}
                                                value={this.props.overallSessionRating.fraction}
                                                showProgressText={true}
                                                progressText={this.props.overallSessionRating.label}
                                            />
                                        </div>
                                    </div>

                                    {
                                        !IsObjectEmpty(this.props.feedbackResponses) && !IsListEmpty(this.props.feedbackResponses.subtopics)
                                            ? <div className={classes.PiechartContainer}>
                                                <p className={classes.DescriptionText}>TOPICS UNDERSTOOD BY STUDENTS</p>
                                                <div className={classes.PieChartDiv}>
                                                    <PieChart
                                                        data={this.props.pieChartData}
                                                    />
                                                    <div className={classes.Legend}>
                                                        <p>Students:</p>
                                                        <p><span className={classes.Green}></span>Completely Understood</p>
                                                        <p><span className={classes.Yellow}></span>Partially Understood</p>
                                                        <p><span className={classes.Red}></span>Did not Understand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }

                                </div>
                            </>
                    }
                </div>
            </>
        )
    }
}


export default DailyReportsCard;